import isNull from 'lodash/isNull'

export default class Modal {
    constructor() {
        this.cacheDom()
        this.bindEvents()
    }

    cacheDom() {
        this.bodyEl = document.body
        this.modal = document.querySelector('.modal')
        this.close = document.querySelector('.close-modal')
        this.toggle = document.querySelectorAll('.close-toggle')
    }

    bindEvents() {
        if (!isNull(this.modal)) {
           Array.prototype.forEach.call(this.toggle,(el, i) => {
               el.addEventListener('click', this.openModal.bind(this))
           })
        }

        if (!isNull(this.close)) {
           this.close.addEventListener('click', this.closeModal.bind(this))
        }
    }

    openModal(e) {
        e.preventDefault()
        this.bodyEl.classList.add('overflow-hidden')
        this.modal.classList.add('is-visible')
    }

    closeModal(e) {
        e.preventDefault()
        this.bodyEl.classList.remove('overflow-hidden')
        this.modal.classList.remove('is-visible')
    }
}